import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { AutocompleteArrayTextInput, ReferenceInput } from '~/components/ra';
import { l, businessRoles } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';

import { Skeleton } from '@material-ui/lab';
import { SelectInput } from 'react-admin';
import { Configuration } from '~/api/solutions';
interface EmployeeNetworkFormProps {
  keyName: string;
  loading?: boolean;
  record?: any;
  configurationRecord?: Configuration;
  basePath: string;
}
export const EmployeeNetworkForm: FC<EmployeeNetworkFormProps> = ({
  keyName,
  loading,
  record,
  configurationRecord,
  basePath,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <AutocompleteArrayTextInput
          label={t('subEmployeeRoles')}
          source={`${keyName}.subEmployeeRoles`}
          record={configurationRecord}
          options={businessRoles}
          freeSolo={false}
        />
      )}

      <ReferenceInput
        source={`${keyName}.subEmployeeAccountProduct`}
        reference='products'
        filter={{ solutionId: record.id }}
        basePath={basePath}
        label={t('subEmployeeAccountProduct')}
        className={classes.inputWidth}
        allowEmpty
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
    </>
  );
};
